import React, { useEffect, useState } from 'react';
import styles from './ProgressBar.module.scss';
import cx from 'classnames';

const ProgressBar = props => {
  const { percentage, readyMsg, className } = props;
  const [width, setWidth] = useState('0%');

  useEffect(() => {
    percentage && setWidth(`${percentage}%`);
  });

  return (
    <div className={cx(styles.wrapper, className)}>
      <div className={styles.container}>
        <div className={styles.filler} style={{ width }}></div>
      </div>
      <div className={styles.percentageValue}>{percentage < 100 ? `${percentage}%` : readyMsg}</div>
    </div>
  );
};

export default ProgressBar;
